import Loadable from 'react-loadable'
import Loading from '../Loading/Loading'

const PdfViewer = Loadable({
  loader: () => import('./PdfViewer'),
  loading: Loading,
})

export default PdfViewer



// WEBPACK FOOTER //
// ./src/components/PdfViewer/index.js